import { render, staticRenderFns } from "./Contacto.vue?vue&type=template&id=78624beb&scoped=true&"
import script from "./Contacto.vue?vue&type=script&lang=ts&"
export * from "./Contacto.vue?vue&type=script&lang=ts&"
import style0 from "./Contacto.vue?vue&type=style&index=0&id=78624beb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78624beb",
  null
  
)

export default component.exports